import React from 'react';
import Table from 'shared/Table';
import { Typography } from '@mui/material';
import { useAppSelector } from 'core/store';
import { TRow } from 'shared/Table/Table.models';

const BookingTable = () => {
  const isLoadingData = useAppSelector((state) => state.dashboard.bookingCSData.isLoading);
  const bookingDataCount = useAppSelector((state) => state.dashboard.bookingCSData.count);
  const bookingData = useAppSelector((state) => state.dashboard.bookingCSData.results);

  return (
    <Table
      showToolbar
      showColumnFilters
      enableStickyHeader
      showGlobalFilter={false}
      isLoading={isLoadingData}
      rowCount={bookingDataCount}
      rows={bookingData as unknown as TRow[]}
      muiTableContainerProps={{ sx: { maxHeight: '600px' } }}
      toolBarStartContent={(
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold' }}
        >
          Contract Management Requests
        </Typography>
      )}
    />
  );
};

export default BookingTable;
